import { Privilege } from "../types/Privileges";

/**
 * Privileges are not listed in the published OpenAPI (`newAPiDocs.json`).
 * Returns an empty list so the UI keeps working until a documented endpoint exists.
 */
export async function fetchPrivileges(_token: string): Promise<Privilege[]> {
  return [];
}
